const list = {
  inputName: 'Nome e Sobrenome',
  inputUsername: 'Usuário',
  inputLogin: 'Login',
  inputCpf: 'CPF',
  inputCellphone: 'Celular',
  inputDdd: 'DDD',
  inputEmail: 'E-mail',
  inputPhoneNumber: 'Celular',
  inputSelect: 'Selecionar',
  inputSearchFarm: 'Pesquise uma fazenda',
  inputWriteHere: 'Digite aqui',
  inputPassword: 'Senha',
  inputNewPassword: 'Nova Senha',
  inputConfirmNewPassword: 'Confirme a Nova Senha',
  inputPasswordHintTitle: 'A senha deve ter:',
  inputConfirmPasswordHintTitle: 'A senha não confere com a digitada',
  inputPasswordHint1: 'Mínimo de 6 caracteres',
  inputPasswordHint2: '1 número',
  inputPasswordHint3: '1 letra minúscula',
  inputPasswordHint4: '1 letra maiúscula',
  inputPasswordHint5: '1 caractere especial (*&$!)',
  inputPasswordHint6: 'Somente números',
  inputConfirmPassword: 'Confirmar senha',
  inputCode: 'Código de verificação',
  buttonActionBack: 'Retornar',
  buttonEnter: 'Entrar',
  buttonAccess: 'Acessar',
  buttonAlter: 'Alterar',
  buttonAltering: 'Alterando',
  buttonEntering: 'Entrando..',
  buttonAcessing: 'Acessando..',
  buttonRegister: 'Cadastrar',
  buttonRegistering: 'Cadastrando...',
  buttonConfirm: 'Confirmar',
  buttonConfirming: 'Confirmando...',
  buttonSend: 'Enviar',
  buttonSending: 'Enviando...',
  buttonGoSelectFarm: 'Selecionar Fazenda',
  buttonBack: 'Voltar',
  validateRequired: 'Campo obrigatório',
  validateInvalidEmail: 'E-mail inválido',
  validateInvalidUsername: 'Usuário inválido',
  validatePhoneMin: 'O telefone deve possuir DDD + 9 dígitos',
  validateMinPassword: 'Senha deve ter 6 dígitos númericos',
  validatePasswordMin: 'Senha deve ter 6 dígitos númericos',
  validatePasswordMax: 'Senha deve ter 6 dígitos númericos',
  validatePasswordOnlyNumbers: 'Senha deve possuir apenas dígitos númericos',
  validatePasswordOneLowercaseCharacter: 'Pelo menos um caractere minúsculo',
  validatePasswordOneUppercaseCharacter: 'Pelo menos um caractere maiúsculo',
  validatePasswordOneNumber: 'Pelo menos um número',
  validatePasswordOneSpecialCharacter: 'Pelo menos um caractere especial ex: @,$,!,%...',
  validatePasswordNotEquals: 'As senhas não são iguais',
  validateCodeOnlyNumber: 'O código só possui números',
  validateCodeFormatInvalid: 'Formato inválido',
  loginNewPassword: 'Você precisa alterar sua senha!',
  codeMismatchExceptionInvalidVerificationCode: 'Código de verificação inválido, tente novamente.',
  forgotPasswordExceptionCodeSendingSuccess: 'Enviamos um código de verificação no seu e-mail. Caso você não receba o e-mail em alguns minutos, verifique sua caixa de spam ou repita o processo.',
  forgotPasswordExceptionContactVerifiedRequired: 'É necessário possuir email ou telefone verificados para recuperar a senha.\nFavor entrar em contato com o suporte +55 19 97144-1818',
  forgotPasswordExceptionDefaultError: 'Erro ao tentar recuperar a senha, tente novamente.',
  forgotPasswordExceptionPasswordChangedSuccessfully: 'Sua senha foi alterada com sucesso!',
  notAuthorizedExceptionIncorrect: 'Usuário ou senha incorretos.',
  userExceptionLogin: 'Ocorreu um erro ao se conectar, tente novamente.',
  userNotFoundExceptionNotFound: 'Usuário não encontrado',
  userNotFoundExceptionNotFoundCustomOnFarm: 'O seu usuário ainda não foi migrado para o Novo OnFarmApp. Clique no link abaixo para acessar o OnFarmApp em operação na sua fazenda:',
  userNotFoundExceptionNotFoundCustomOnFarmStore: 'O seu usuário ainda não foi migrado para o Novo OnFarmApp. Clique no link abaixo para acessar a loja em operação para sua fazenda: ',
  usernameExistsExceptionEmailAlreadyExists: 'Uma conta com o Login fornecido já existe.',
  userNotConfirmedExceptionUserIsNotConfirmed: 'Usuário não confirmado.',
  userNotFoundExceptionEmailAndPhoneNotFound: 'É necessário cadastrar email e telefone',
  userNotFoundExceptionPhoneNotFound: 'É necessário cadastrar telefone, contate o suporte',
  userNotFoundExceptionEmailNotFound: 'É necessário cadastrar email, contate o suporte',
  loginColumnLeftTitle: 'É o primeiro acesso? Cadastre-se aqui!',
  loginColumnLeftRegister: 'Cadastrar',
  loginTitle: 'Acesse sua conta',
  loginResetPassword: 'Esqueci minha senha',
  userApp: 'Usuário APP',
  passwordUserApp: 'Senha',
  registerColumnLeftTitle: 'Já possui cadastro? Clique aqui!',
  registerColumnLeftLogin: 'Login',
  registerTitle: 'Faça seu cadastro',
  registerColumnRightNotify: 'Eu aceito receber alertas de novos conteúdos por e-mail',
  confirmSignUpWelcome: 'Bem-vindo',
  confirmSignUpTitle: 'Um Código de Verificação foi enviado para o e-mail cadastrado, insira o código para continuar:',
  confirmSignUpResendConfirmationCode: 'Reenviar código',
  confirmSignUpCodeResentSuccessfully: 'Código enviado com sucesso',
  confirmSignUpErrorResendingCode: 'Erro ao enviar código, tente novamente.',
  confirmSignUpVerifiedUser: 'Usuário verificado com sucesso.',
  confirmSignUpVerifiedAlreadyUser: 'Usuário já verificado.',
  userContactTitle: 'Por favor informe seu email e seu telefone para que possa seguir com a utilização do sistema.',
  userContactDone: 'Email e celular cadastrados!',
  confirmContactTitlePhone: 'O código de verificação foi enviado para seu celular, por favor informe-o abaixo.',
  confirmContactTitleEmail: 'O código de verificação foi enviado para seu email, por favor informe-o abaixo.',
  confirmContactInputPhoneNumber: 'Reenviar código',
  confirmContactInputEmail: 'Código enviado com sucesso',
  confirmContactErrorResendingCode: 'Erro ao enviar código, tente novamente.',
  confirmContactVerifiedUser: 'Contato verificado com sucesso.',
  newFarmTitle: 'Cadastre agora uma fazenda.',
  newUserTitle: 'Cadastre seu usuário.',
  accessFarmWelcome: 'Bem-vindo(a)',
  accessFarmTitle: 'Acesso liberado para:',
  selectFarmConfirmation: 'Selecione a fazenda para avançar: ',
  almostThere: 'Estamos quase lá: ',
  nowSelectFarmCategory: 'Agora selecione a categoria desejada: ',
  forgotPasswordTitle: 'Informe o login do usuário cadastrado.',
  passwordRecoveryTitle: 'Informe o código que enviamos no seu e-mail e cadastre uma nova senha',
  newPasswordInputTitle: 'Informe a nova senha que gostaria de usar',
  typeReceivedNewPasswordTitle: 'Agora informe de que forma gostaria de receber uma nova senha',
  newPasswordTitle: 'Defina uma nova senha',
  typeReceivedPasswordEmail: 'Receber por email',
  typeReceivedPasswordSms: 'Receber por Sms',
  passwordSentSuccess: 'Senha enviada com sucesso confira seu email/sms',
  noPoints: 'Não quero usar pontos',
  signUpTitle: 'Informe seus dados de cadastro',
  registerError: 'Erro ao registrar usuário, tente novamente.',
  labelDigiteNomeUsuario: 'Digite o nome do usuário',
  labelDigiteSenha: 'Digite a senha',
  labelSelecioneFazendaAvancar: 'Selecione a fazenda para avançar',
  labelBemVindo: 'Bem-vindo',
  labelCarregando: 'Carregando',
}

export default list;